// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mxKX4cuApPWa5m8IaiI0{margin:0}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/ui/WhenDropdown/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA","sourcesContent":[".icon {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `mxKX4cuApPWa5m8IaiI0`
};
export default ___CSS_LOADER_EXPORT___;
